import { axiosPrivate } from "@app/dashboard/tools/axios/axiosInstance"

export const getMerchantName = (merchantId: string) => {
    return axiosPrivate.get(`/bills/api/v1/distributor/merchants/${merchantId}/company_name/`)
}